import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IFavorites } from "./models";

const initialState: IFavorites = {
  success: false,
};

export default function favoritesReducer(
  state: IFavorites,
  action: Action,
): IFavorites {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const favorites = (action as PayloadAction<IFavorites>).payload;
      return { ...favorites };
    }
    default:
      return state;
  }
}
